import * as React from "react";

interface IImportPniTableStatus {
  status: string;
}

function ImportPniStatus({ status }: IImportPniTableStatus) {
  
    const getStatus = () => {
    switch (status) {
      case "PROCESSADO":
        return <span>Processado</span>;
      case "PROCESSANDO":
        return <span>Processando</span>;
      case "ERROR":
        return <span>Error</span>;
      default:
        return <span>Aguardando Processamento</span>;
    }
  };
  return <div>{getStatus()}</div>;
}

export default ImportPniStatus;



// WEBPACK FOOTER //
// ./src/component/administration/registers/import-pni/importPniStatus.tsx